module.exports = __webpack_public_path__ + "img/0c4250e0b55bc6dd3c9ec076782078f0.50d0b3f2.jpg";